(function() {
  $(document).ready(function() {
    $(document).on("click", ".swell-share-referral-copy", function() {
      setTimeout(function(){
        detachReferralCopy();
        $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html().replace("http://",""));
      },20);
    });
    $('body').on('click', '.swell-referral-back-link.checkout', function(e){
      $(".filippo-loreti-rewards").hide();
    });
    $('body').on('click', '.swell-referral-back-link', function(e){
      $(".swell-referral").removeClass("thankyou");
      $(".swell-referral-sidebar-details").show();
    });
    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
        $(".refer-customer-error").remove();
        $(".swell-referral-sidebar-details").show();
        $(".swell-referral").removeClass("thankyou");
        $(".swell-referral-content-container").addClass("error-message");
        $("#swell-referral-refer-emails").addClass("error-border");
      if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
      }
      else if(textStatus && textStatus === "Please enter a valid email address"){
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
      }
    });
    $(document).on("swell:setup", function() {
      $(".spinner-icon").remove();
      if($(".swell-campaigns").length>0){
        Swell.Campaign.initializeCampaigns(".swell-campaigns", SwellConfig.Campaign.opts);
        $(".swell-campaigns .swell-campaign:nth-child(5)").after("<li class='swell-campaign'> <div class='swell-campaign-content newsletter'> <i class='swell-icon swell-icon-newsletter'><span class='path1'></span> <span class='path2'></span></i> <div class='swell-campaign-value'> 25 Points </div> <div class='swell-campaign-type'> Newsletter Signup </div> </div> </li>");
        SwellConfig.Campaign.appendCustomCampaign(".swell-campaigns");
        SwellConfig.Campaign.authenticate();
        $(document).on('click', '.swell-campaign-content.newsletter', function(){
          swellAPI.showPopupByType("EmailCapturePopup"); 
        });
      }
      if($(".swell-tier-table").length>0){
        SwellConfig.Tier.initializeDummyTier();
        SwellConfig.Tier.initializeCustomTierProperties();
        SwellConfig.Tier.initializeTiers(".swell-tier-table");
        setupSlickSlider();
      }
      if($(".product-redemption-list").length>0){
        var options = spapi.activeRedemptionOptions;
        for(var t=0;t<options.length;t++){
          if(options[t].discount_type == "product"){
            $(".product-redemption-list").append('<li class="swell-option"> <div class="image-holder"> <img src="'+options[t].background_image_url+'"> </div> <div class="data-holder"> <div class="swell-title">'+options[t].name+'</div> <div class="swell-amount">'+options[t].amount+' Points</div> <div class="swell-redemption-link swell-buy-product-btn" data-variant-id="'+options[t].applies_to_id+'" data-hide-logged-out="true|false" data-confirm-title="Are you sure?" data-confirm-content="You currently have *|point_balance|* points available. This product costs *|amount|* points to redeem." data-confirm-btn-text="Yes, buy it" data-error-type="red" data-error-title="Whoops!" data-error-content="Looks like you do not have enough points for this product. This product costs *|amount|* points and you only have *|point_balance|* points available." data-error-okay-text="Ok" data-success-type="green" data-success-title="Success!" data-success-content="Product was successfully added to your cart" data-success-ok-btn="Keep Shopping" data-success-cart-btn="View Cart" data-success-cart-link="/cart" data-box-width="400px" data-mobile-box-width="90%">REDEEM NOW</div> </div> </li>');
          }
        }
        setupProductSlider();
      }
      if($(".swell-referral").length>0){
        SwellConfig.Referral.initializeReferral(".swell-referral");
        if(spapi.authenticated || (spapi.customer.referral_receipts && spapi.customer.referral_receipts.length > 0)) {
          setupReferrals();
        }
        $(document).on("swell:referral:success", function(jqXHR, textStatus, errorThrown) {
          thankyou();
        });
        $('body').on('click', '.swell-referral-copy', function(e){
          if($(e.target).hasClass("swell-referral-copy")) {
            e.stopPropagation();
          }
        });
        $(".filippo-loreti-rewards").css("display","flex");
      }
    });
  });
}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: "<li class='swell-campaign'> <div class='swell-campaign-content' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'> <i class='swell-icon <%= campaign.icon %>'><span class='path1'></span> <span class='path2'></span></i> <div class='swell-campaign-value'> <%= campaign.reward_text %> </div> <div class='swell-campaign-type'> <%= campaign.title %> </div> </div> </li>"
      }
    },
    appendCustomCampaign: function(containerSelector) {
      $(containerSelector).append("<li class='swell-campaign custom-brand-name'> <div class='swell-campaign-content'> <div class='swell-campaign-value-custom'>FILIPPO LORETI</div> </div> </li>");
    },
    authenticate: function() {
      $(".swell-campaigns").addClass("loaded");
      if (spapi.authenticated) {
        $(".swell-campaign").css("cursor", "pointer");
      }
    }
  };
}).call(this);


(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "VIP Insider"
      });
    },
    initializeCustomTierProperties: function() {
      spapi.activeVipTiers[0].points = "Create an account",
      spapi.activeVipTiers[0].benefits = "<span class='benefit-item'>1- 1x Point multiplier</span> <span class='benefit-item'>2- Free shipping orders over $50</span> <span class='benefit-item'>3- Access to secret prod launches</span> <span class='benefit-item'>4- Private VIP sales event</span>",
      
      spapi.activeVipTiers[1].points = "Spend: $"+(spapi.activeVipTiers[1].amount_spent_cents/100)+" - $"+((spapi.activeVipTiers[2].amount_spent_cents/100)-1),
      spapi.activeVipTiers[1].benefits = "<span class='benefit-item'>1- 1.5x Point multiplier</span> <span class='benefit-item'>2- Free shipping all orders</span> <span class='benefit-item'>3- Access to secret prod launches</span> <span class='benefit-item'>4- Private VIP sales event</span> <span class='benefit-item'>5- 15% off coupon upon tier entry</span> <span class='benefit-item'>6- Free strap for your watch</span> <span class='benefit-item'>7- Exclusive personalization services</span>",
      
      spapi.activeVipTiers[2].points = "Spend: $"+(spapi.activeVipTiers[2].amount_spent_cents/100)+"+",
      spapi.activeVipTiers[2].benefits = "<span class='benefit-item'>1- 2x Point multiplier</span> <span class='benefit-item'>2- Free expedited shipping</span> <span class='benefit-item'>3- Access to secret prod launches</span> <span class='benefit-item'>4- Private VIP sales event</span> <span class='benefit-item'>5- 20% off coupon upon tier entry</span> <span class='benefit-item'>6- Free strap for your watch</span> <span class='benefit-item'>7- Exclusive personalization services</span> <span class='benefit-item'>8- VIP customer support</span> <span class='benefit-item'>9- Access to founder created watches(zoom calls to also gather feedback)</span>"
    },
    initializeTiers: function(containerSelector) {
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      var next_info = "";
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      if(customer_tier_rank == null){
        customer_tier_rank = 0;
      }
      for(var t=0;t<tiers.length;t++)
      {
        if(t==customer_tier_rank && spapi.authenticated){
          tiers[t].current_status="<span class='current-status-item'>CURRENT STATUS</span>";
        }
        else{
          tiers[t].current_status="";
        }
      }
      $(containerSelector).append("<div class='tier-holder'></div>");
      var check = true;
      for(var t=0;t<tiers.length;t++)
      {
        if((customer_tier_rank==null || t==customer_tier_rank) && spapi.authenticated)
        {
          if(t<2){
            if(spapi.customer.vip_tier_stats != undefined){
              var amount = (tiers[t+1].amount_spent_cents-spapi.customer.vip_tier_stats.amount_spent_cents)/100;
              if(amount < 0){
                amount = 0;
              }
              next_info = "Spend $"+amount+" more for "+tiers[t+1].name;
            }
          }
          if(customer_tier_rank==null && check){
            if(spapi.customer.vip_tier_stats != undefined){
              var amount = (tiers[t].amount_spent_cents-spapi.customer.vip_tier_stats.amount_spent_cents)/100;
              if(amount < 0){
                amount = 0;
              }
              next_info = "Spend $"+amount+" more for "+tiers[t].name;
            }
            $(".tier-holder").append("<div class='tier-"+(t+1)+"-col active'><span class='next-info-item'>"+next_info+"</span><div class='top-holder'>  <span class='name-item'>"+tiers[t].name+"</span> <span class='points-item'>"+tiers[t].points+"</span> </div><div class='benefit-holder'> <span class='benefit-title'> <span class='holder'>Benefits</span> </span> <div class='tier-benefits'>"+tiers[t].benefits+"</div> </div> </div>");
            next_info = "";
            check = false;
          }
          else{
            $(".tier-holder").append("<div class='tier-"+(t+1)+"-col active'>"+tiers[t].current_status+"<div class='top-holder'><span class='name-item'>"+tiers[t].name+"</span><span class='points-item'>"+tiers[t].points+"</span> </div> <div class='benefit-holder'> <span class='benefit-title'><span class='holder'>Benefits</span></span><div class='tier-benefits'>"+tiers[t].benefits+"</div></div></div>");
          }
        }
        else
        {
          $(".tier-holder").append("<div class='tier-"+(t+1)+"-col'><span class='next-info-item'>"+next_info+"</span><div class='top-holder'><span class='name-item'>"+tiers[t].name+"</span><span class='points-item'>"+tiers[t].points+"</span> </div> <div class='benefit-holder'> <span class='benefit-title'><span class='holder'>Benefits</span></span><div class='tier-benefits'>"+tiers[t].benefits+"</div></div></div>");
          next_info = "";
        }
      }
    }
  }
}).call(this);

function setupSlickSlider(){
  $('.swell-tier-table .tier-holder').slick({
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: null,
    prevArrow: null,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  if($(window).width()<769){
    $('.swell-tier-table .tier-holder').slick("slickGoTo",SwellConfig.Tier.getCustomerTierRank() == null ? 0:SwellConfig.Tier.getCustomerTierRank());
  }
}

// referral
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "REFER A FRIEND",
        referralSidebarDetailsReward: "",

        referralRegisterHeading: "GIVE <%= referralCampaign.reward_text %>, GET <%= referralCampaign.reward_text %>",
        referralRegisterFormDetails: "Enter your email to get started.",
        referralRegisterFormEmail: "Your email...",
        referralRegisterFormSubmit: "NEXT",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: "GIVE <%= referralCampaign.reward_text %>, GET <%= referralCampaign.reward_text %>",
        referralReferFormEmails: "Your friends’ email (seprated by commas)",
        referralReferFormSubmit: "SEND",
        referralReferFormDetails: "Now, Enter your friends’ emails.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "you can also share the link with<br class='swell-mobile'> the buttons below.",

        referralShareFacebook: "Share",
        referralShareCopy: "Copylink",
        referralShareSMS: "SMS",
        referralShareMessenger: "Message",

        referralFacebookIcon: "swell-icon-fb",
        referralLinkIcon: "swell-icon-copy",
        referralSMSIcon: "swell-icon-sms",
        referralMessengerIcon: "swell-icon-message",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "Copy Link",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <div class="swell-referral-details-container"><p class="swell-referral-details"><%= localization.referralRegisterDetails %></p></div><div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" class="swell-referral-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-button"> <div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </div> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <div class="swell-referral-details-container"><p class="swell-referral-details"><%= localization.referralReferDetails %></p></div><div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> </li> <li class="swell-referral-form-list-button"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i><%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-sms" aria-hidden="true"></i>SMS</div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"></i><%= localization.referralShareMessenger %></div> </li> <li class=\"swell-referral-medium swell-share-referral-twitter\"> <div class="swell-referral-medium-content"> <i class=\"swell-icon-tweet\" aria-hidden=\"true\"></i>Tweet</div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i><%= localization.referralShareCopy %></div> </li> </ul> </div> </div>',
        referralCopy: '<div class="swell-referral-copy"> <div class="swell-referral-copy-content"> <img class="swell-copy-banner swell-desktop" src="//cdn.shopify.com/s/files/1/0020/1896/7605/t/219/assets/swell-copy-desktop.png?v=23525665021045247481646393768"> <img class="swell-copy-banner swell-mobile" src="//cdn.shopify.com/s/files/1/0020/1896/7605/t/219/assets/swell-copy-mobile.png?v=81334050645153188271646393768"> <div class="swell-referral-copy-main"> <span class="swell-referral-back-link"></span> <h2 class="swell-referral-heading"> </h2> <div class="swell-referral-form-wrapper"> <div class="swell-referral-link swell-referral-copy-link" id="swell-referral-copy-link"></div> <button class="swell-referral-copy-button" id="swell-referral-copy-button" data-clipboard-target="#swell-referral-copy-link"> <%= localization.referralCopyHeading %> </button> <p class="swell-referral-details"> <%= localization.referralCopyDetails%> </p> </div> </div> </div> </div>'
      }
    },
    initializeReferral: function(containerSelector) {
      var email = $(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      $(".swell-referral").show();
    }
  };
}).call(this);

function setupReferrals(){
  $(".swell-referral-content").show();
  $(".border").show();
  if(spapi.customer.referral_receipts.length > 0) {
    $(".referral-table").show();
    referrals = spapi.customer.referral_receipts;

    referrals.forEach(function(referral) {
      status = null;
      if(referral.completed_at){ 
        status = "purchased "+spapi.activeReferralCampaign.reward_text+" (earned)";
      } else {
        status = "invited";
      }
      $(".swell-referral-table tbody").append('<tr> <td> <div class="trucate-email">' +  referral.email + '</div></td><td>' + status +'</td></tr>');
    });  
  }
}

function detachReferralCopy(){
  if($(".swell-referral-copy").length > 0){
    $("body").append($(".swell-referral-copy").detach());
  }
}

function thankyou(){
  $(".swell-referral-sidebar-details").hide();
  $(".swell-referral").addClass("thankyou");
  swellAPI.refreshCustomerDetails(function(){
    $(".swell-referral-table tbody").html("");
    referrals = spapi.customer.referral_receipts;
    referrals.forEach(function(referral) {
      status = null;

      if(referral.completed_at){ 
        status = "Purchased ("+spapi.activeReferralCampaign.prettyReward+" earned)";
      } else {
        status = "Invited";
      }

      $(".swell-referral-table tbody").append('<tr> <td> <div class="trucate-email">' +  referral.email + '</div></td><td>' + status +'</td></tr>');
    });
  });
}
